import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { auditLogsApi } from '../services/auditLogApi';
import type { AuditLogParams } from '../services/auditLogApi';

export const useAuditLogs = (params: AuditLogParams) => {
  return useQuery({
    queryKey: ['audit-logs', params],
    queryFn: () => auditLogsApi.getPaged(params),
    placeholderData: keepPreviousData,
  });
};
